export default "__VITE_ASSET__CK6eHB0$__"